import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a6123c66"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdminCategoryToolbar: require('/app/components/AdminCategoryToolbar.vue').default,Loading: require('/app/components/Loading.vue').default,Breadcrumb: require('/app/components/Breadcrumb.vue').default,BreadcrumbStructuredData: require('/app/components/BreadcrumbStructuredData.vue').default,TruncateText: require('/app/components/TruncateText.vue').default,ProductList: require('/app/components/ProductList.vue').default,H7ComparisonBanner: require('/app/components/H7ComparisonBanner.vue').default,FaqList: require('/app/components/FaqList.vue').default,CategoryListItem: require('/app/components/CategoryListItem.vue').default,HomeTrustBar: require('/app/components/HomeTrustBar.vue').default})
